export class ProductReleases {
    public id: number;
    public displayName: String;
    public rmVmwPrdRelId: number;
    public rmVmwPrdRelVersion: String;
    public rmVmwPrdRelGADate: Date | string;
    public cVmwProductId: number;
    public cmRelPublishDate: Date | string;
    public isSupport: boolean;
    public description: String;
    public lastUpdate: Date;
    public updatedBy: String;
}



// WEBPACK FOOTER //
// ./src/app/models/productreleases.ts